<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">新质企业智能问数系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          新质企业智能问数系统是面向企业经营者的对话式数据分析平台。系统以企业指标中心为底座，将分散在 ERP、财务、销售、供应链、人力等业务系统中的数据进行统一接入与口径治理，用户通过自然语言提问即可完成取数、制图与分析，无需编写 SQL 或等待数据部门排期。
        </p>
        <p class="content-paragraph">
          系统提供“问数—洞察—推送—决策”的闭环能力：语义解析自动转换为查询语句，多轮追问持续下钻；指标异常自动识别并给出归因分析，日报、周报、月报自动生成并按时推送至企业微信或邮箱；按组织、角色、数据域精细化授权，确保数据可用不可见、口径统一可追溯，帮助企业把数据真正用于日常经营决策。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">自然语言问数</h3>
            <ul class="capability-list"><li>语义解析</li><li>NL2SQL</li><li>多轮追问</li><li>口径统一</li><li>自动制图</li><li>结果导出</li><li>问答留痕</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">指标与看板</h3>
            <ul class="capability-list"><li>指标中心</li><li>口径定义</li><li>经营驾驶舱</li><li>部门看板</li><li>同比环比</li><li>目标达成</li><li>自定义看板</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">智能洞察推送</h3>
            <ul class="capability-list"><li>异常发现</li><li>归因分析</li><li>趋势预测</li><li>报告生成</li><li>订阅推送</li><li>预警提醒</li><li>决策建议</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/wd-chat.svg"
              alt="海南华德科技有限公司 新质企业智能问数系统 - 问数工作台 · 对话式取数与分析"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>问数工作台 · 对话式取数与分析
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/wd-board.svg"
              alt="海南华德科技有限公司 新质企业智能问数系统 - 经营驾驶舱 · 指标统一口径看板"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>经营驾驶舱 · 指标统一口径看板
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/wd-mobile.svg"
              alt="海南华德科技有限公司 新质企业智能问数系统 - 移动端 · 随身问数与指标订阅"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>移动端 · 随身问数与指标订阅
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/wd-metric.svg"
              alt="海南华德科技有限公司 新质企业智能问数系统 - 指标中心 · 口径治理与权限管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>指标中心 · 口径治理与权限管理
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs14.vue